import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";

export const Slider = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const { t } = useTranslation()
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState([]);

    const getDataa = async () => {
        setLoading(true);

        try {
            const headerss = {
                "accept": "*/*",
                'Access-Control-Allow-Credentials': 'false',
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json'
            }
            await axios({
                method: 'get',
                url: "https://express.heryerdeingilizce.com/sa",
                headers: headerss
            }).then(res => {
                console.log(res.data)
                setToken("https://www.paytr.com/odeme/guvenli/" + res.data);

            }
            );

        }
        catch (err) {
            setMsg(err);
        }
        setLoading(false);

    }
    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.paytr.com/js/iframeResizer.min.js";
        script.async = true;
        document.body.appendChild(script);

        getDataa();
    }, []);


    return (
        <div>
            <iframe src={token} id="paytriframe" frameborder="0" style={{ width: "100%", height: "1000px" }}></iframe>
        </div>
        // <div className="row">
        //     {msg}
        //     {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}


        //     <h2>Mevcut Görseller Listesi</h2>
        //     {!loading && (

        //         <div className='row' >
        //             <h4>Yüklenecek olan resimler 1920*1080 boyutlarında olmalıdır.</h4>
        //             <hr />
        //             <div className='col'>
        //                 <h6>1. Resim</h6><br />
        //                 <img src={slider1} />
        //                 <hr />
        //                 <div style={{ alignItems: "center" }}>
        //                     <form onSubmit={sliderImage1}>
        //                         <div class="mb-3">
        //                             <label for="schoollogo" class="form-label">{t("image")}</label>
        //                             <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={sliderImage1} id="imagePath1" name="schoollogo" required />
        //                         </div>
        //                         <button type="submit" class="btn btn-primary btn-lg">{t("UploadImage")}</button>
        //                     </form>
        //                 </div>
        //             </div>
        //             <div className='col'>
        //                 <h6>2. Resim</h6><br />
        //                 <img src={slider2} />
        //                 <hr />
        //                 <div style={{ alignItems: "center" }}>
        //                     <form onSubmit={sliderImage2}>
        //                         <div class="mb-3">
        //                             <label for="schoollogo" class="form-label">{t("image")}</label>
        //                             <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={sliderImage2} id="slider2up" name="slider2up" required />
        //                         </div>
        //                         <button type="submit" class="btn btn-primary btn-lg">{t("UploadImage")}</button>
        //                     </form>
        //                 </div>
        //             </div>
        //             <div className='col'>
        //                 <h6>3. Resim</h6><br />
        //                 <img src={slider3} />
        //                 <hr />
        //                 <div style={{ alignItems: "center" }}>
        //                     <form onSubmit={sliderImage3}>
        //                         <div class="mb-3">
        //                             <label for="schoollogo" class="form-label">{t("image")}</label>
        //                             <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={sliderImage3} id="imagePath1" name="schoollogo" required />
        //                         </div>
        //                         <button type="submit" class="btn btn-primary btn-lg">{t("UploadImage")}</button>
        //                     </form>
        //                 </div>
        //             </div>
        //             <div className='col'>
        //                 <h6>4. Resim</h6><br />
        //                 <img src={slider4} />
        //                 <hr />
        //                 <div style={{ alignItems: "center" }}>
        //                     <form onSubmit={sliderImage4}>
        //                         <div class="mb-3">
        //                             <label for="schoollogo" class="form-label">{t("image")}</label>
        //                             <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={sliderImage4} id="imagePath1" name="schoollogo" required />
        //                         </div>
        //                         <button type="submit" class="btn btn-primary btn-lg">{t("UploadImage")}</button>
        //                     </form>
        //                 </div>
        //             </div>
        //             <div className='col'>
        //                 <h6>5. Resim</h6><br />
        //                 <img src={slider5} />
        //                 <hr />
        //                 <div style={{ alignItems: "center" }}>
        //                     <form onSubmit={sliderImage5}>
        //                         <div class="mb-3">
        //                             <label for="schoollogo" class="form-label">{t("image")}</label>
        //                             <input class="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={sliderImage5} id="imagePath1" name="schoollogo" required />
        //                         </div>
        //                         <button type="submit" class="btn btn-primary btn-lg">{t("UploadImage")}</button>
        //                     </form>
        //                 </div>
        //             </div>

        //         </div>
        //     )}
        // </div>
    )
}
export default Slider;